// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"s_bs","reference__name":"s_bt","reference__required":"s_bv"};